// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import {
  defineRepositoryItemId,
  type RepositoryItemId,
  type RepositoryItemIdString
} from 'cadenza/repository/model/repository-item-id';

/** @see net/disy/cadenza/repository/api/datasource/DataSourceId.java */
export type DataSourceId = RepositoryItemId<'DATA_SOURCE'>;
/** @see net/disy/cadenza/repository/api/datasource/DataSourceId.java */
export const DataSourceId = defineRepositoryItemId('DATA_SOURCE');
/**
 * @knipignore
 * @see net/disy/cadenza/repository/api/datasource/DataSourceId.java
 */
export type DataSourceIdString = RepositoryItemIdString<'DATA_SOURCE'>;

// </GENERATED-CODE>
